import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

type ClassValue = string | undefined;


export default /*@__PURE__*/_defineComponent({
  __name: 'layoutSection',
  props: {
    lifted: { type: Boolean },
    maxWidthClass: {},
    paddingClass: {},
    contentClass: {},
    containerClass: {},
    sectionClass: {}
  },
  setup(__props: any) {

const props = __props;

const maxWidthClass = computed(() => props.maxWidthClass ?? 'max-w-[1100px] mx-auto');
const paddingClass = computed(() => props.paddingClass ?? 'py-6 sm:py-7 md:py-8 lg:py-10');
const contentClass = computed(() => props.contentClass ?? '');
const containerClass = computed(() => props.containerClass ?? '');
const sectionClass = computed(() => props.sectionClass ?? '');
const lifted = computed(() => props.lifted ?? false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['container mx-auto px-8', lifted.value ? 'sm:mt-[9rem] md:mt-[-5rem]' : '', paddingClass.value, sectionClass.value, containerClass.value])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['w-full', maxWidthClass.value, contentClass.value])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})